<!--PRINT BUTTON-->
<button class="border-none" [useExistingCss]="true" printSectionId="print-section" ngxPrint>
  <i class="icon cursor red print small"></i>
</button>
<!--END PRINT BUTTON-->
